import { CityDistrictsPermissions } from "./cities.districts.permissions";
import { CitiesPermissions } from "./cities.permissions";
import { CountryGeographicalZonesPermissions } from "./countries.geographical-zones.permissions";
import { CountriesPermissions } from "./countries.permissions";
import { CountryStatesPermissions } from "./countries.states.permissions";
import { DistrictsPermissions } from "./districts.permissions";
import { GeographicalZonesPermissions } from "./geographical-zones.permissions";
import { StateCitiesPermissions } from "./states.cities.permissions";
import { StatesPermissions } from "./states.permissions";

export class LocationManagementPermissions {

  static Countries = CountriesPermissions.Permissions;
  static CountryGeographicalZones = CountryGeographicalZonesPermissions.Permissions;
  static CountryStates = CountryStatesPermissions.Permissions;

  static States = StatesPermissions.Permissions;
  static StateCities = StateCitiesPermissions.Permissions;

  static Cities = CitiesPermissions.Permissions;
  static CityDistricts = CityDistrictsPermissions.Permissions;

  static Districts = DistrictsPermissions.Permissions;
  static GeographicalZones = GeographicalZonesPermissions.Permissions;
  }


export function getLocationManagementModuleName() {
  return 'LocationManagement';
}
